/**
 * catalogConfigBuilder — configs do catálogo pedagógico (níveis de ensino,
 * áreas do conhecimento, titulações, regras de rematrícula).
 *
 * @since H.1 (pedagógico novo)
 */
import type { $Fetch } from 'ofetch';

import {
  HttpEducationLevelGateway, HttpKnowledgeAreaGateway,
  HttpTitulacaoGateway, HttpRegraRematriculaGateway,
} from '@/infrastructure/http/HttpCatalogConfigGateways';
import {
  ListEducationLevels, CreateEducationLevel, UpdateEducationLevel,
  ListKnowledgeAreas, CreateKnowledgeArea, UpdateKnowledgeArea,
  ListTitulacoes, CreateTitulacao, UpdateTitulacao,
  ListRegrasRematricula, CreateRegraRematricula, UpdateRegraRematricula,
} from '@/application/usecase/CatalogConfigUseCaseImpl';

export function buildCatalogConfigSlice(httpClient: $Fetch) {
  const educationLevelGateway = new HttpEducationLevelGateway(httpClient);
  const knowledgeAreaGateway = new HttpKnowledgeAreaGateway(httpClient);
  const titulacaoGateway = new HttpTitulacaoGateway(httpClient);
  const regraRematriculaGateway = new HttpRegraRematriculaGateway(httpClient);

  const useCases = {
    listEducationLevels: new ListEducationLevels(educationLevelGateway),
    createEducationLevel: new CreateEducationLevel(educationLevelGateway),
    updateEducationLevel: new UpdateEducationLevel(educationLevelGateway),
    listKnowledgeAreas: new ListKnowledgeAreas(knowledgeAreaGateway),
    createKnowledgeArea: new CreateKnowledgeArea(knowledgeAreaGateway),
    updateKnowledgeArea: new UpdateKnowledgeArea(knowledgeAreaGateway),
    listTitulacoes: new ListTitulacoes(titulacaoGateway),
    createTitulacao: new CreateTitulacao(titulacaoGateway),
    updateTitulacao: new UpdateTitulacao(titulacaoGateway),
    listRegrasRematricula: new ListRegrasRematricula(regraRematriculaGateway),
    createRegraRematricula: new CreateRegraRematricula(regraRematriculaGateway),
    updateRegraRematricula: new UpdateRegraRematricula(regraRematriculaGateway),
  };

  return { useCases };
}
